import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Program', prop: 'program_id', references: 'admin/programs', referenceProp: 'name' },
  { title: 'Start', prop: 'start_at', format: 'date' },
  { title: 'End', prop: 'end_at', format: 'date' },
  { title: 'Groups', prop: 'groups_count' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true },
  { name: 'Filter by program', prop: 'filters.program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const Sessions = (props) => (
  <List
    title='Sessions'
    apiPath='admin/sessions'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default Sessions
